import { Card, CardContent, Chip, Divider, Grid, Typography } from "@mui/material";
import { CalendarToday, Email, Home, Person, Phone, WorkspacePremiumOutlined } from "@mui/icons-material";
import { differenceInDays } from "date-fns";
import moment from "moment";
import React from "react";

import { IProposalList } from "../../../../shared/services/api/proposal/ProposalService";
import InfoItemWithCopy from "../../../../shared/components/InfoItemWithCopy/InfoItemWithCopy";
import {
	globalbackgroundProposal,
	globalColorTextProposal,
	globalMaskDocument,
	globalTranslateStatus,
	maskPhone,
} from "../../../../shared/utils";

interface ProposalBasicCardDataProps {
	row: IProposalList;
}

export const ProposalBasicCardData: React.FC<ProposalBasicCardDataProps> = ({ row }) => {
	const statusKey =
		row.status === "active" &&
		row.renovatedId &&
		differenceInDays(
			new Date(row.termBegin ? row.termBegin.substring(0, 10) + " 03:00:00" : "2021-01-01 03:00:01"),
			new Date().toISOString().substring(0, 10) + " 03:00:00"
		) > 0
			? "renovated"
			: row.status;

	const addressText =
		row.addressStreet != null && row.addressStreet !== ""
			? row.addressComplement != null && row.addressComplement !== ""
				? `${row.addressStreet}, ${row.addressNumber ?? ""} - ${row.addressComplement} - ${row.addressDistrict ?? ""} - ${row.addressCity ?? ""} - ${row.addressState ?? ""} - ${row.addressZipcode ?? ""}`
				: `${row.addressStreet}, ${row.addressNumber ?? ""} - ${row.addressDistrict ?? ""} - ${row.addressCity ?? ""} - ${row.addressState ?? ""} - ${row.addressZipcode ?? ""}`
			: "";

	return (
		<Card sx={{ margin: "auto", px: 4, borderRadius: 4, ml: 1, mt: 0.5, width: "100%" }}>
			<CardContent>
				<Grid container spacing={2}>
					<Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center">
						<Typography variant="h6" color="primary">
							Dados da garantia
						</Typography>
						<Chip
							size="medium"
							label={` ${globalTranslateStatus(row.status)}`}
							sx={{
								color: globalColorTextProposal(statusKey),
								background: globalbackgroundProposal(statusKey),
								fontWeight: 500,
							}}
						/>
					</Grid>

					<Grid item xs={12}>
						<Divider />
					</Grid>

					<Grid item xs={12} md={6}>
						<InfoItemWithCopy
							label="Nome"
							value={`${row.name ?? ""} (${globalMaskDocument(row.document ?? "")})`}
							icon={<Person />}
						/>
					</Grid>

					<Grid item xs={12} md={3}>
						<InfoItemWithCopy
							label="Nascimento"
							value={row.birthDate && row.birthDate !== "1899-11-30" ? moment(row.birthDate).format("L") : ""}
							icon={<CalendarToday />}
						/>
					</Grid>

					<Grid item xs={12} md={3}>
						<InfoItemWithCopy
							label="Criada"
							value={row.createdAt ? moment(row.createdAt).format("L") : ""}
							additionalInfo={row.createdAt ? moment(row.createdAt).startOf("day").fromNow() : ""}
							icon={<CalendarToday />}
						/>
					</Grid>

					<Grid item xs={12}>
						<InfoItemWithCopy label="Endereço" value={addressText} icon={<Home />} />
					</Grid>

					<Grid item xs={12} md={4}>
						<InfoItemWithCopy label="Email" value={row.email ?? ""} icon={<Email />} />
					</Grid>

					<Grid item xs={12} md={4}>
						<InfoItemWithCopy
							label="Certificado"
							value={row.certificateNumber ?? ""}
							icon={<WorkspacePremiumOutlined />}
						/>
					</Grid>

					<Grid item xs={12} md={4}>
						<InfoItemWithCopy label="Telefone" value={maskPhone(row.mobilePhone ?? "")} icon={<Phone />} />
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
